import { useCookies } from "vue3-cookies";
import Api from '@/constants/api';
import router from "./router";

class ApiClient {
  constructor(axios) {
    this.$axios = axios;
    this.$cookies = useCookies().cookies;

    this._setup();
  }

  _setup() {
    this.$axios.interceptors.response.use(
      (res) => res,
      async (err) => {
        if (err.response?.status === 401) {
          this.$cookies.remove('access_token');
          await router.push({ name: 'Login' });
          return Promise.resolve(null);
        }
        return Promise.reject(err);
      }
    );
  }

  async billingAddress(billingId) {
    const s = await this.$axios.get(Api.PATH_SESSION)
      .catch((e) => e.response);
    if (s?.data?.status !== Api.STATUS_SUCCESS) {
      this.$cookies.remove('access_token');
      await this.$router.push({ name: 'Login' });
      return;
    }
    const r = await this.$axios.get(Api.PATH_BILLING_ADDRESS, {
      params: {
        billing_id: billingId,
      },
    }).catch((e) => e.response);
    if (r?.status !== 200) throw 'API_BILLING_ADDRESS failed. http-status=' + r.status;
    if (!r.data) throw 'API_BILLING_ADDRESS failed. no-data';
    if (r.data.status !== Api.STATUS_SUCCESS) throw 'API_BILLING_ADDRESS failed. status=' + r.data.status;

    return {
      ...r.data,
      billing_id: billingId,
      role_id: s.data.session?.role_id
    };
  }

  async billingAddressUpdate(values) {
    const r = await this.$axios.post(Api.PATH_BILLING_ADDRESS_UPDATE, {
      access_token: this.$cookies.get('access_token'),
      ...values
    }).catch((e) => e.response);
    return r?.data?.status === Api.STATUS_SUCCESS;
  }
}

let client = null;

export function useApiClient() {
  return client;
}

export default function api(app) {
  app.config.globalProperties.$api = client = new ApiClient(
    app.config.globalProperties.$axios ?? app.config.globalProperties.axios
  );
}
